import { Button, RawHtml, Typography } from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import { useFrame } from '~/shared/utils';
import styles from './SuccessStep.module.scss';

type SuccessStepProps = {
    reservationNumber: string;
    onClose: () => void;
};

export const SuccessStep = ({ reservationNumber, onClose }: SuccessStepProps) => {
    const { translate } = useTranslation();
    const { data: frame } = useFrame();

    return (
        <>
            <div className={styles.messageWrapper}>
                <Typography as="p" variant="paragraph-M">
                    {translate('pdp.reservationNumber1')} <strong>{reservationNumber}</strong>{' '}
                    {translate('pdp.reservationNumber2')}
                </Typography>
                {frame?.market?.reservationSuccessText && (
                    <RawHtml
                        html={frame.market.reservationSuccessText}
                        className={styles.successStepRichText}
                    />
                )}
            </div>
            <Button className={styles.closeButton} onClick={onClose}>
                {translate('pdp.closeDrawer')}
            </Button>
        </>
    );
};
